<template>
    <teleport to="body">
        <transition name="think-fade" appear>
            <div v-if="visible" class="think-popup-model" @click.self="handleClose" role="dialog" aria-modal="true">
                <transition name="think-zoom" appear>
                    <div class="relative top-40px">
                        <div class="absolute top--80px left--20px rounded-50 overflow-hidden">
                            <img :src="info.avatar" class="w-56px h-56px" />
                        </div>
                        <div class="absolute top--20px left-0">
                            <img src="@/assets/images/message/yun.svg" class="w-32px h-37px"  />
                        </div>
                        <div v-show="visible" class="think-popup-content" aria-live="polite">
                            <div class="think-popup-content-title">
                                Thinking
                            </div>
                            <div class="think-popup-content-message max-h-300px overflow-y-auto">
                                {{ thinkConetnt }}
                            </div>
                        </div>
                        <div class="flex justify-center items-center mt-30px">
                            <img src="@/assets/images/message/close.svg" class="w-24px h-24px" @click="handleClose" />
                        </div>
                    </div>
                </transition>
            </div>
        </transition>
    </teleport>
</template>

<script setup lang="ts">
import { watch, onBeforeUnmount } from 'vue'
const visible = defineModel<boolean>('visible', { required: true })
defineProps<{
    info: any
    thinkConetnt: string
}>()
const handleClose = () => {
    visible.value = false
}

const lockScroll = () => {
    const original = document.body.style.overflow
    if (original !== 'hidden') {
        document.body.setAttribute('data-think-original-overflow', original || '')
        document.body.style.overflow = 'hidden'
    }
}

const unlockScroll = () => {
    const original = document.body.getAttribute('data-think-original-overflow')
    document.body.style.overflow = original || ''
    document.body.removeAttribute('data-think-original-overflow')
}

watch(visible, (val) => {
    if (val) {
        lockScroll()
    } else {
        unlockScroll()
    }
}, { immediate: true })

onBeforeUnmount(() => {
    unlockScroll()
})
</script>
<style scoped>
.think-popup-model {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    box-sizing: border-box;
}

.think-popup-content {
    width: 100%;
    max-width: 279px;
    background: #fff;
    border-radius: 12px;
    padding: 20px 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
}

.think-popup-content-title {
    font-size: 12px;
    font-weight: 600;
    color: #777;
    margin-bottom: 8px;
}

.think-popup-content-message {
    font-size: 14px;
    color: #000000;
    line-height: 1.6;
}

/* Overlay fade */
.think-fade-enter-active,
.think-fade-leave-active {
    transition: opacity 0.25s ease;
}

.think-fade-enter-from,
.think-fade-leave-to {
    opacity: 0;
}

/* Content zoom + slight slide */
.think-zoom-enter-active {
    transition: transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.28s ease;
}

.think-zoom-leave-active {
    transition: transform 0.2s ease, opacity 0.2s ease;
}

.think-zoom-enter-from,
.think-zoom-leave-to {
    transform: scale(0.96) translateY(8px);
    opacity: 0;
}
</style>